import React from 'react';
import './PageHeader.scss';

type Props = {
  text: string;
  imageUrl: string;
};

const PageHeader = (props: Props) => {
  const {
    text = '',
    imageUrl = '',
  } = props;
  return (
    <div className="page-header">
      <div className="page-header__text">
        <h1>{text}</h1>
      </div>
      <div className="page-header__img">
        <img src={imageUrl} alt="Product" />
      </div>

    </div>
  );
};

export default PageHeader;
